import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateQuantityUnitForm from "../../forms/CreateOrUpdateQuantityUnitForm";
import { QuantityUnitResponseDto } from "../../shared/dtos/quantityUnit/QuantityUnitResponseDto";

interface UpdateQuantityUnitModalProps {
  open: boolean;
  onClose: () => void;
  unit: QuantityUnitResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateQuantityUnitModal: React.FC<UpdateQuantityUnitModalProps> = ({
  open,
  onClose,
  unit,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit Unit: ${unit.name}`}
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateQuantityUnitForm
      isEditing={true}
      unit={unit}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateQuantityUnitModal;
